import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { DataService } from '@app/services';
import { OperationGuard } from '@app/guards';

@Injectable({
  providedIn: 'root'
})
export class SignupGuard implements CanActivate {
    
    constructor (
        private router: Router,
        private dataService: DataService,
        private operationGuard: OperationGuard
    ) {}
    
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {  
        return this.checkSignup(route);            
    }
       
    async checkSignup(route: ActivatedRouteSnapshot){        
        let operationID = route.queryParamMap.get('o');        
        let statusOperation = await this.operationGuard.checkOperation(route, operationID);         
        if(statusOperation !== true){
            return statusOperation;
        }
        else if(this.dataService.operation.signupContent?.isEnabled !== true){
            return this.router.parseUrl('home');
        }
        return true;
    }
}
